<template>
    <div class="alf">
        <div class="alf-head">
            <span class="ak-label alf-label">{{ label }}</span>
            <div class="alf-modes" role="group" :aria-label="label">
                <button v-if="allowInherit" type="button" :class="{ on: modelValue.mode === 'inherit' }"
                    @click="setMode('inherit')">Inherit</button>
                <button type="button" :class="{ on: modelValue.mode === 'custom' }" @click="setMode('custom')">Custom</button>
                <button type="button" :class="{ on: modelValue.mode === 'unlimited' }"
                    @click="setMode('unlimited')">{{ unlimitedLabel }}</button>
            </div>
        </div>
        <input v-if="modelValue.mode === 'custom'" type="number" min="1" step="1" class="ak-input"
            :value="modelValue.value" :placeholder="placeholder" @input="onInput">
        <p v-else-if="modelValue.mode === 'inherit'" class="alf-note">Uses the plan's value.</p>
        <p v-else class="alf-note">{{ unlimitedLabel }}.</p>
        <p v-if="hint" class="ak-hint alf-hint">{{ hint }}</p>
    </div>
</template>

<script>
export default {
    name: 'ApiLimitField',
    props: {
        label: { type: String, required: true },
        hint: { type: String, default: '' },
        modelValue: { type: Object, required: true },
        allowInherit: { type: Boolean, default: false },
        unlimitedLabel: { type: String, default: 'Unlimited' },
        placeholder: { type: String, default: '' },
    },
    emits: ['update:modelValue'],
    methods: {
        setMode(mode) {
            this.$emit('update:modelValue', { mode, value: this.modelValue.value });
        },
        onInput(e) {
            const raw = e.target.value;
            this.$emit('update:modelValue', { mode: 'custom', value: raw === '' ? '' : Number(raw) });
        },
    },
};
</script>

<style scoped>
.alf { display: flex; flex-direction: column; gap: 0.4rem; }
.alf-head { display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; flex-wrap: wrap; }
.alf-label { margin: 0; }
.alf-modes { display: inline-flex; border: 1px solid #e2e8f0; border-radius: 10px; overflow: hidden; background: #f8fafc; }
.alf-modes button {
    border: none; background: transparent; padding: 0.3rem 0.65rem; font-size: 0.72rem; font-weight: 700;
    color: var(--text-secondary); cursor: pointer; font-family: var(--font-sans);
}
.alf-modes button + button { border-left: 1px solid #e2e8f0; }
.alf-modes button.on { background: #0071C5; color: #fff; }
.alf-note { margin: 0; padding: 0.6rem 0.9rem; border-radius: 10px; background: #f8fafc; color: #64748b; font-size: 0.82rem; font-weight: 600; }
.alf-hint { margin: 0; }
</style>
